<template>
    <div class="text-gray-900 font-medium text-lg relative mb-5">
        <div class="relative inline-block z-10">
            <div class="z-10 relative">
                <slot></slot>
            </div>
            <div class="shadow-bar absolute w-full bg-gray-10 top-[13px] left-[10px] z-[2]"></div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.shadow-bar {
    height: calc(100% - 12px);
}
</style>
